import React from 'react';
import { motion } from 'framer-motion';

const AboutMission = () => {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          className="text-left mb-8"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack mb-6">
            Our Mission
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-4xl">
            Our mission is to help clients move forward with confidence by ensuring their documentation is well prepared, clearly organized, and supported by reliable processes. We focus on reducing delays, errors, and unnecessary complexity in administrative workflows.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutMission;
